export class StyledBoxModel {
  public static transparent = 'rgba(0, 0, 0, 0)';
}
